// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kv-c";
export var backButton = "_kv-4";
export var backIcon = "_kv-5";
export var chevronShortcut = "_kv-6";
export var container = "_kv-1";
export var editor = "_kv-8";
export var editorWrapper = "_kv-7";
export var prefix = "_kv-2";
export var searchIcon = "_kv-3";
export var suffix = "_kv-9";
export var suffixContent = "_kv-a";
export var suffixText = "_kv-b";
export var wrapper = "_kv-0";